import { Card, Row, Col } from 'react-bootstrap';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BaseFeature from './BaseFeature';
import { fetchDriverPermissions, fetchLockedFeatures } from '../../../../../../actions';
import ConfigLockForm from './components/ConfigLockForm';
import PropertyTableCheckbox from './components/PropertyTableCheckbox';
import PropertySwitch from './components/PropertySwitch';
import PropertyRadio from './components/PropertyRadio';
import { CONFIGURATION_LOCK } from '../../../../../../utils/constantFeatures';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../utils/validationSummary';
import { X_API_KEY } from '../../../../../../utils/authentication';
import { Trans, withTranslation } from 'react-i18next';

class ConfigurationLock extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            isEnabled: this.props.properties[CONFIGURATION_LOCK.enable].value === "1" ? true : false,
            showLockedfeatures: this.props.properties[CONFIGURATION_LOCK.fullOrPartialProtection] !== undefined ? this.props.properties[CONFIGURATION_LOCK.fullOrPartialProtection].value === '0' : 'false',
            isEnabledMaster: this.props.properties[CONFIGURATION_LOCK.enable].value === "1" ? true : false,
            isEnabledService: this.props.properties[CONFIGURATION_LOCK.servicePassword] && this.props.properties[CONFIGURATION_LOCK.servicePassword].value === "Off" ? false : true,
            type: this.props.properties[CONFIGURATION_LOCK.masterPassword].valueMeta.max === "9999" ? 1 : 2,
            showMasterKeyInput: false,
            showServiceKeyInput: false,
            showEditKeys: false,
            originalMasterKey: null,
            originalServiceKey: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
        this.handleChangeMasterKey = this.handleChangeMasterKey.bind(this);
        this.handleServiceKeyChange = this.handleServiceKeyChange.bind(this);
        this.handleEditKeysClick = this.handleEditKeysClick.bind(this);
    }

    handleEditKeysClick() {
        const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];
        const keySp = this.props.properties[CONFIGURATION_LOCK.servicePassword];
        this.setState({
            showEditKeys: true,
            originalMasterKey: keyMp.value,
            originalServiceKey: keySp.value
        });
    }

    handleServiceKeyChange(name, value) {
        this.props.handleChange(name, value);
    }

    componentDidMount() {
        this.props.fetchDriverPermissions(this.props.project.id, this.props.driver.driverId);
        this.props.fetchLockedFeatures(this.props.project.id, this.props.driver.driverId)
    }

    handleChange(propertyName, value) {
        if (this.props.properties[CONFIGURATION_LOCK.fullOrPartialProtection]) {

            if (propertyName === 'key.all') {
                if (value === '0') {
                    this.setState({ showLockedfeatures: true })
                } else {
                    this.setState({ showLockedfeatures: false })
                }
            }
        }

        const v = value;
        const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];

        // Mark user as actively editing if they type in a key field
        const corrected = this.getCorrectPropertyName(propertyName);

        if (corrected === CONFIGURATION_LOCK.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
            this.setState({ isEnabledMaster: v === "1" ? true : false });

            if (v !== "1") {
                this.setState({ isEnabledService: false });
            }

            // Keep imported secured projects blanked (master key "0") when lock is already enabled.
            const shouldKeepImportedBlankMasterKey =
                v === "1" && String(keyMp?.value) === "0" && String(this.props.properties[CONFIGURATION_LOCK.enable]?.value) === "1";

            this.props.handleChange(
                CONFIGURATION_LOCK.masterPassword,
                v === "1" ? (shouldKeepImportedBlankMasterKey ? "0" : keyMp.valueMeta.min) : "Off"
            );
        } else if (corrected === CONFIGURATION_LOCK.servicePassword) {

            if (v === 0 || v === "Off") {
                this.setState({ isEnabledService: false });
            }
        }

        this.props.handleChange(propertyName, v);
    }

    handleChangeEnabled(e) {
        const value = e.target.checked;
        switch (e.target.name) {
            case "service":
                this.setState({
                    isEnabledService: value
                });

                this.props.handleChange(CONFIGURATION_LOCK.servicePassword, value ? "2" : "Off");
                break;
            default:
                break;
        }
    }

    handleChangeMasterKey(e) {
        const value = e.target.value;
        const name = e.target.name;
        if (value > 9999) {
            return
        }

        this.props.handleChange(name, value ? value : "Off");
    }

    areKeysSet() {
        /*   const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];
        const keyEn = this.props.properties[CONFIGURATION_LOCK.enable];
        const keyEm = this.props.properties[CONFIGURATION_LOCK.keyEncrypted];
        return String(keyMp?.value) === "1" && String(keyEn?.value) === "1" && String(keyEm?.value) === "1"; */

        // this will be enabled when there will be a way to show the label
        return false;
    }

    renderKeysAlreadySetMessage() {
        if (!this.areKeysSet() || this.state.showEditKeys) {
            return null;
        }

        return (
            <span style={{ color: '#888', fontSize: '0.95rem' }}>
                <Trans i18nKey="Keys_already_set">Master key and service keys are already set. If you want to change them, </Trans>
                <span
                    style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={this.handleEditKeysClick}
                >
                    <Trans i18nKey="click_here">click here</Trans>
                </span>
                .
            </span>
        );
    }

    renderTypeKeyCard() {
        switch (this.state.type) {
            case 1:
                const keyAll = this.props.properties[CONFIGURATION_LOCK.fullOrPartialProtection];
                if (keyAll) {
                    return (
                        <Row style={{ margin: "0.75rem auto 0" }}>
                            <Col sm={6}>
                                <PropertyRadio
                                    property={keyAll}
                                    valueForTrue={"1"}
                                    isChecked={keyAll.value === "1"}
                                    title={'All'}
                                    handleChange={this.handleChange} />
                            </Col>
                            <Col sm={6}>
                                <PropertyRadio
                                    property={keyAll}
                                    valueForTrue={["0", "Off"]}
                                    isChecked={keyAll.value === "0"}
                                    title={'Partial'}
                                    handleChange={this.handleChange} />
                            </Col>
                        </Row>);
                }
                else {
                    return null;
                }
            case 2:
                const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];
                const keySp = this.props.properties[CONFIGURATION_LOCK.servicePassword];
                const keyEn = this.props.properties[CONFIGURATION_LOCK.enable];
                const modifiedKeySp = this.state.showEditKeys ? { ...keySp, value: "" } : keySp;

                return (
                    <Row className={''} style={{ margin: "0.5rem auto 0" }}>
                        <Col sm={1} className="center" style={{ padding: '0', margin: "auto 0" }}>
                            <Checkbox
                                disabled={keyEn.value === "0"}
                                name={"service"}
                                checked={this.state.isEnabledService}
                                onChange={this.handleChangeEnabled} />
                        </Col>
                        <Col sm={4} style={{ margin: "auto 0" }}>
                            {keySp.info.displayName}
                        </Col>
                        <Col sm={7} style={{ margin: "auto 0" }}>
                            <ConfigLockForm
                                disabled={!this.state.isEnabledService}
                                property={modifiedKeySp}
                                title={keyMp.info.displayName}
                                numberOfKeys={4}
                                handleChange={this.handleChange} />
                        </Col>
                    </Row>
                );
            default:
                break;
        }
    }

    renderTypeFeaturesCard() {
        switch (this.state.type) {
            case 1:
                return null;
            case 2:
                let className = 'card-feature-component';
                if (!this.state.isEnabled) {
                    className += ' card-disabled';
                    //className += ' card-none';
                }

                const keyPs = this.props.properties[CONFIGURATION_LOCK.permissionService];
                const keyPu = this.props.properties[CONFIGURATION_LOCK.permissionUser];

                return (
                    <Card className={className + " " + this.getClassName([keyPu, keyPs])}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Access_to_Features" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', minWidth: '400px' }}>
                            {/* pass this.props.permissions */}
                            <PropertyTableCheckbox
                                disabled={!this.state.isEnabled}
                                properties={this.props.permissions}
                                permissionUser={keyPu}
                                permissionService={keyPs}
                                isEnabledService={this.state.isEnabledService}
                                isEnabledMaster={this.state.isEnabledMaster}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                );
            default:
                break;
        }
    }

    renderMasterKey() {
        const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];

        switch (this.state.type) {
            case 1:
                const errors = getErrorIssues(this.props.issues, this.props.property);
                const warnings = getWarningIssues(this.props.issues, this.props.property);
                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                return (
                    <div style={{ paddingRight: "0" }}>
                        <input
                            style={{ width: "100%" }}
                            disabled={!this.state.isEnabledMaster}
                            className={className}
                            name={keyMp.info.name}
                            type="number"
                            min={keyMp.valueMeta.min}
                            max={keyMp.valueMeta.max}
                            step={1}
                            value={this.state.showEditKeys ? "" : keyMp.value}
                            onChange={this.handleChangeMasterKey} />

                        {getIssuesComponent(errors, warnings)}
                    </div>
                );
            case 2:
                const modifiedKeyMp = this.state.showEditKeys ? { ...keyMp, value: "" } : keyMp;
                return (
                    <ConfigLockForm
                        disabled={!this.state.isEnabledMaster}
                        property={modifiedKeyMp}
                        title={keyMp.info.displayName}
                        numberOfKeys={4}
                        handleChange={this.handleChange} />
                );
            default:
                break;
        }
    }

    render() {
        const keyEn = this.props.properties[CONFIGURATION_LOCK.enable];
        const keyMp = this.props.properties[CONFIGURATION_LOCK.masterPassword];
        const keySp = this.props.properties[CONFIGURATION_LOCK.servicePassword];

        const warningTextDemo =
            localStorage.getItem(X_API_KEY) !== undefined && localStorage.getItem(X_API_KEY) !== null && localStorage.getItem(X_API_KEY) === ''
                ? (<Row style={{ margin: "0.75rem", width: "22rem" }}>
                    <p style={{ color: "#ff0000" }}><b>Please do not enter your company secret master and service keys in public mode!</b></p>
                    <p>Please apply for a private company workspace at <a href="mailto:T4Tsupport@inventronicsglobal.com">T4Tsupport@inventronicsglobal.com</a><br />
                        if you use password protection in your LED drivers.</p>
                </Row>)
                : null;

        return (
            <div className="flex-row">
                <Card className={this.getClassName([keyEn, keyMp, keySp])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="Configuration_Lock" />}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <Row style={{ margin: "0.75rem auto 0" }}>
                            <PropertySwitch
                                property={keyEn}
                                title={keyEn.info.displayName}
                                className={'enable-configuration-lock'}
                                handleChange={this.handleChange} />
                        </Row>

                        {this.renderKeysAlreadySetMessage()}
                        {(!this.areKeysSet() || this.state.showEditKeys) && (
                            <>
                                <Row style={{ margin: "0.75rem auto 0" }}>
                                    <Col sm={5} style={{ padding: '0', margin: "auto 0" }}>
                                        {keyMp.info.displayName}
                                    </Col>
                                    <Col sm={7} style={{ margin: "auto 0" }}>
                                        {this.renderMasterKey()}
                                    </Col>
                                </Row>
                                {this.renderTypeKeyCard()}
                            </>
                        )}
                        {warningTextDemo}
                    </Card.Body>
                </Card>
                {this.state.showLockedfeatures === true &&
                    <Card className={this.getClassName([keyEn, keyMp, keySp])}>
                        <div className="card-header-feature">
                            {'Locked Feature(s)'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {this.props.lockedFeatures.map(e =>
                                <Row style={{ margin: "0.75rem auto 0" }}>
                                    {e}
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                }
                {this.renderTypeFeaturesCard()}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        permissions: state.driver.permissions,
        issues: state.project.issueByProperty,
        lockedFeatures: state.driver.lockedFeatures
    };
};

const mapDispatchToProps = {
    fetchDriverPermissions,
    fetchLockedFeatures
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(ConfigurationLock);
